<template>
  <form @submit.prevent="onSubmit">
    <label>
      <slot />
      <input
        class="w-full border-3 bg-white rounded-4 border-gray-200 text-18 font-semibold mb-3 mx-0 p-3 outline-none"
        type="email"
        pattern='^([^<>()\[\]\\.,;:\s@"]+(?:\.[^<>()\[\]\\.,;:\s@"]+)*)@((?:[a-zA-Z\-0-9]+\.)+[a-zA-Z][a-zA-Z0-9-]*[a-zA-Z0-9])$'
        @invalid="onInvalid"
        @input="onInput"
        name="email"
        v-model="email"
        :required="!optional"
        :placeholder="$t('email_address')"
      />
    </label>
    <button type="submit" class="btn btn-sm btn-amber w-full mb-6">
      {{ submitLabel }}
    </button>
    <p class="text-12 lg:text-14">
      {{ conditionsText }}
      {{ $t('unsubscribe_anytime') }}
      <a :href="$t('privacy_policy_url')" class="underline" target="_blank" rel="noopener">{{
        $t('read_policy')
      }}</a>
    </p>
  </form>
</template>

<script lang="ts" setup>
const { $t } = useNuxtApp()
const emit = defineEmits(['submit'])

defineProps<{
  submitLabel: string
  conditionsText: string
  optional?: boolean
}>()

const email = ref('')

function onInvalid(event: Event) {
  const target = event.target as HTMLInputElement
  target.setCustomValidity($t('errors.invalid_email'))
}

function onInput(event: Event) {
  const target = event.target as HTMLInputElement
  target.setCustomValidity('')
}

function onSubmit() {
  emit('submit', email.value)
}
</script>
